import React, { FC, useMemo } from 'react'

import { NotifyMe as NotifyMeUI, NotifyMeProps } from '@Components/CMS/NotifyMe'
import { Block } from '@Generated/graphql'
import { getJSONFieldValue } from '@Globals/CMS/FieldHelpers'

const getBlockData = (notifyMeBlock: Block): NotifyMeProps => ({
  identifyingLabel: getJSONFieldValue(notifyMeBlock.fields || [], 'identifyingLabel') || '',
  submitText: getJSONFieldValue(notifyMeBlock.fields || [], 'submitButtonText') || '',
  thankYouText: getJSONFieldValue(notifyMeBlock.fields || [], 'thankYouText') || '',
})

interface NotifyMeBlockProps {
  id?: string
  notifyMeBlock: Block
}

const NotifyMeBlock: FC<NotifyMeBlockProps> = ({ id, notifyMeBlock }) => {
  const blockProps = useMemo(() => getBlockData(notifyMeBlock), [notifyMeBlock])

  return <NotifyMeUI {...blockProps} id={id} />
}

export default NotifyMeBlock
